{
  "page": {
    "title": "Seeder danych",
    "description": "Tworzy testowe talenty z avatarami i pinami przez zwykłe API. Tylko development i QA.",
    "frameTitle": "Talenty",
    "viewModeConfig": "Konfiguracja",
    "viewModeResult": "Podgląd",
    "viewModeSplit": "Obok siebie",
    "hostNotAllowed": "Seeder danych działa tylko na localhost, development i QA.",
    "sidebarLink": "Seeder danych"
  },
  "config": {
    "presets": "Presety",
    "preset": {
      "quick": "10 na szybko",
      "heavy-shortlist": "Ciężka shortlista 500",
      "edge-cases": "Przypadki brzegowe"
    },
    "basics": "Paczka",
    "seed": "Seed",
    "seedHelp": "Ten sam seed i ustawienia dają tych samych ludzi.",
    "newSeed": "Nowy seed",
    "count": "Talenty",
    "resourceType": "Typ zasobu",
    "membership": "Widoczność",
    "names": "Pochodzenie imion",
    "namesHelp": "Waga dla języka; 0 go pomija.",
    "locale": {
      "en": "Angielskie",
      "pl": "Polskie",
      "de": "Niemieckie",
      "fr": "Francuskie",
      "it": "Włoskie",
      "es": "Hiszpańskie",
      "ja": "Japońskie",
      "pt_BR": "Brazylijskie"
    },
    "details": "Dane",
    "fill": {
      "email": "E-mail",
      "phone": "Telefon",
      "role": "Rola"
    },
    "avatars": "Avatary",
    "avatarsHelp": "Waga dla stylu; buzie losowane z seeda.",
    "rerollFaces": "Inne buzie",
    "avatarSource": {
      "lorelei": "Lorelei",
      "notionists": "Notionists",
      "avataaars": "Avataaars",
      "open-peeps": "Open Peeps",
      "micah": "Micah",
      "personas": "Personas",
      "photo": "Zdjęcia",
      "none": "Bez avatara"
    },
    "pins": "Piny",
    "pinCount": "Pinów na talent: {{min}}–{{max}}",
    "portraitShare": "Pionowe: {{percent}}%",
    "pinSource": {
      "photos": "Zdjęcia",
      "faces": "Buzie"
    },
    "edgeCases": "Przypadki brzegowe: {{percent}}%",
    "edgeCasesHelp": "Bardzo długie lub niełacińskie imiona, talenty bez żadnych danych, 40 pinów.",
    "shortlist": "Shortlista",
    "createShortlist": "Dodaj paczkę do nowej shortlisty",
    "shortlistTitle": "Tytuł",
    "shortlistWorkspace": "Workspace",
    "shortlistTeam": "Zespół",
    "noWorkspace": "Organizacja (bez workspace'u)",
    "pickTeam": "Wybierz zespół",
    "run": "Utwórz {{count}} talentów"
  },
  "preview": {
    "title": "Podgląd: pierwsze {{shown}} z {{count}}",
    "loadFailed": "Nie udało się narysować podglądu: {{message}}",
    "noDetails": "Brak danych",
    "pinCount_one": "{{count}} pin",
    "pinCount_few": "{{count}} piny",
    "pinCount_many": "{{count}} pinów",
    "pinCount_other": "{{count}} pinu"
  },
  "run": {
    "talents": "Tworzę talenty: {{done}} z {{total}}",
    "shortlist": "Uzupełniam shortlistę…",
    "stopping": "Zatrzymuję po talentach w toku…",
    "stop": "Zatrzymaj",
    "failures_one": "{{count}} błąd",
    "failures_few": "{{count}} błędy",
    "failures_many": "{{count}} błędów",
    "failures_other": "{{count}} błędu",
    "failure": "#{{index}}: {{message}}",
    "status": {
      "done": "Paczka utworzona",
      "stopped": "Zatrzymano",
      "auto-stopped": "Zatrzymano po 5 błędach z rzędu",
      "restored": "Ostatnia paczka"
    },
    "created_one": "Utworzono {{count}} talent",
    "created_few": "Utworzono {{count}} talenty",
    "created_many": "Utworzono {{count}} talentów",
    "created_other": "Utworzono {{count}} talentu",
    "batchTag": "Tag {{tag}}",
    "showTalents": "Pokaż talenty",
    "openShortlist": "Otwórz shortlistę",
    "shortlistFailed": "Shortlista się nie udała: {{message}}",
    "archive": "Archiwizuj tę paczkę",
    "archived": "Zarchiwizowano",
    "failed": "Uruchomienie nie powiodło się: {{message}}"
  }
}
